var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTitle', {
    attrs: {
      "title": "Результаты тестирования"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "loading": _vm.uploadExcel,
      "color": "primary"
    },
    on: {
      "click": _vm.chooseExcelFile
    }
  }, [_c('input', {
    ref: "excelInput",
    staticClass: "upload-excel-input",
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx"
    },
    on: {
      "change": _vm.uploadFromExcel
    }
  }), _c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-table-arrow-down")]), _vm._v(" Загрузить из EXCEL ")], 1), _c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "color": "primary",
      "loading": _vm.downloadExcel
    },
    on: {
      "click": _vm.downloadFromExcel
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-table-arrow-up")]), _vm._v(" Сохранить в EXCEL ")], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTable', {
    attrs: {
      "table-loading": _vm.tableLoading,
      "table-headers": _vm.tableHeaders,
      "filter": "",
      "table-items": _vm.applicationParent.list,
      "table-height": "284"
    },
    scopedSlots: _vm._u([{
      key: "item.testScore",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-col', [_c('v-text-field', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: '####',
            expression: "'####'"
          }],
          attrs: {
            "full-width": "",
            "hide-details": "",
            "rounded": "",
            "outlined": "",
            "dense": ""
          },
          on: {
            "change": function change($event) {
              return _vm.saveApplication(item);
            }
          },
          model: {
            value: item.testScore,
            callback: function callback($$v) {
              _vm.$set(item, "testScore", $$v);
            },
            expression: "item.testScore"
          }
        })], 1)];
      }
    }, {
      key: "item.averageScore",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-col', [_c('v-text-field', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: '#.##',
            expression: "'#.##'"
          }],
          attrs: {
            "full-width": "",
            "hide-details": "",
            "rounded": "",
            "outlined": "",
            "dense": ""
          },
          on: {
            "change": function change($event) {
              return _vm.saveApplication(item);
            }
          },
          model: {
            value: item.averageScore,
            callback: function callback($$v) {
              _vm.$set(item, "averageScore", $$v);
            },
            expression: "item.averageScore"
          }
        })], 1)];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return undefined;
      }
    }])
  }, [_c('transition', {
    attrs: {
      "name": "curator-filter"
    }
  }, [_c('TestResultFilterDialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFilter,
      expression: "showFilter"
    }],
    attrs: {
      "test-result-filter": _vm.testResultFilter,
      "width-filter": "300",
      "top": "255",
      "right": "29"
    },
    on: {
      "applyFilter": _vm.applyFilter,
      "closeFilter": function closeFilter($event) {
        _vm.showFilter = false;
      }
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }